module.exports = "/images/qualify-service.svg?e200605acad2065727aa29866957cc8c";